import { TRAVELER_TYPE, Locale, LanguageCode } from '@flysas-tech/book-value-stream-models';

import { languageCodeMap, POS } from '../constants';
import { PAX_TYPE } from '../schemas/sas-domain';

import { assertUnreachable } from './types';

const parsePos = (posText: string): POS | undefined => Object.values(POS).find(pos => pos === posText);

export const getLanguageCodeFromPos = (posText: string) => {
  const pos = parsePos(posText);
  return pos ? languageCodeMap[pos] : 'en';
};

export const getLanguageCode = (locale: Locale): LanguageCode => {
  const lang = locale.split('-')?.[0] ?? 'en';
  return lang === 'nb' ? 'no' : Object.values(LanguageCode).find(l => l === lang) ?? 'en';
};

export const reverseLanguageCode = (locale: Locale) => {
  return locale.split('-').reverse().join('-');
};

export const reverseLocale = (locale: Locale) => {
  return locale.split('-').reverse().join('-');
};

export const getPsgTravelerType = (type: PAX_TYPE | TRAVELER_TYPE) => {
  const travelerType = type as TRAVELER_TYPE;
  switch (travelerType) {
    case TRAVELER_TYPE.ADULT:
      return 'ADULT';
    case TRAVELER_TYPE.CHILD:
      return 'CHILD';
    case TRAVELER_TYPE.INFANT:
      return 'INFANT';
    case TRAVELER_TYPE.YOUTH:
      return 'YOUTH';
    case TRAVELER_TYPE.UNACCOMPANIED_MINOR:
      return 'UNACCOMPANIED_MINOR';
    default:
      assertUnreachable(travelerType);
  }
};

export const getPsgPrimaryTravelerTypes = () => {
  return [
    getPsgTravelerType(TRAVELER_TYPE.ADULT),
    getPsgTravelerType(TRAVELER_TYPE.YOUTH),
    getPsgTravelerType(TRAVELER_TYPE.UNACCOMPANIED_MINOR),
  ];
};

export function isObject(variable: unknown): boolean {
  return variable !== null && typeof variable === 'object';
}

/**
 *
 * @param value The number to round
 * @param decimals The number of decimal places to round to (default is 2)
 * @returns The rounded number
 */
export function round(value: number, decimals: number = 2): number {
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
